import { toBooleanFromBit } from './productHelpers';

export const sortDetailTabs = (tabs = []) =>
  [...tabs].sort(
    (a, b) =>
      Number(a.DisplayOrder || 0) - Number(b.DisplayOrder || 0) ||
      String(a.TabKey || '').localeCompare(String(b.TabKey || '')),
  );

const buildTypeLookup = (activeTabTypes = []) => {
  const map = new Map();
  (activeTabTypes || []).forEach((type) => {
    if (type?.TabKey) {
      map.set(type.TabKey, type);
    }
  });
  return map;
};

const parseContentConfig = (value) => {
  if (value == null || value === '') return {};
  if (typeof value === 'object') return value;
  try {
    return JSON.parse(String(value));
  } catch {
    return {};
  }
};

export const normalizeDetailTabsFromApi = (productTabs, activeTabTypes = []) => {
  const apiTabs = Array.isArray(productTabs) ? productTabs : [];
  const tabMap = new Map(apiTabs.map((tab) => [tab.TabKey, tab]));
  const typeLookup = buildTypeLookup(activeTabTypes);

  (activeTabTypes || []).forEach((type) => {
    if (!tabMap.has(type.TabKey)) {
      tabMap.set(type.TabKey, {
        DetailTabId: null,
        TabKey: type.TabKey,
        TabTitle: type.DefaultTitle,
        IsVisible: false,
        DisplayOrder: type.DisplayOrder ?? 0,
        TypeDefaultTitle: type.DefaultTitle,
        HelpText: type.HelpText,
        ContentType: type.ContentType,
        ContentConfig: type.ContentConfig,
        Placement: type.Placement,
      });
    }
  });

  return sortDetailTabs(
    [...tabMap.values()].map((tab) => {
      const typeMeta = typeLookup.get(tab.TabKey);
      return {
        DetailTabId: tab.DetailTabId ?? null,
        ProductId: tab.ProductId ?? null,
        TabKey: tab.TabKey,
        TabTitle: tab.TabTitle || typeMeta?.DefaultTitle || tab.TypeDefaultTitle || tab.TabKey,
        IsVisible: toBooleanFromBit(tab.IsVisible, true),
        DisplayOrder: Number(tab.DisplayOrder) || Number(typeMeta?.DisplayOrder) || 0,
        TypeDefaultTitle: tab.TypeDefaultTitle || typeMeta?.DefaultTitle || '',
        HelpText: tab.HelpText || typeMeta?.HelpText || '',
        ContentType: tab.ContentType || typeMeta?.ContentType || '',
        ContentConfig: parseContentConfig(tab.ContentConfig || typeMeta?.ContentConfig),
        Placement: tab.Placement || typeMeta?.Placement || 'tab',
      };
    }),
  );
};

export const buildDetailTabsSavePayload = (tabs = [], activeTabTypes = []) => {
  const typeLookup = buildTypeLookup(activeTabTypes);
  return sortDetailTabs(tabs).map((tab, index) => ({
    DetailTabId: tab.DetailTabId || null,
    TabKey: tab.TabKey,
    TabTitle: (
      tab.TabTitle
      || typeLookup.get(tab.TabKey)?.DefaultTitle
      || tab.TypeDefaultTitle
      || tab.TabKey
      || ''
    ).trim(),
    IsVisible: tab.IsVisible === false ? 0 : 1,
    DisplayOrder: index + 1,
  }));
};

const serializeDetailTabsPayload = (tabs, activeTabTypes) =>
  JSON.stringify(buildDetailTabsSavePayload(tabs, activeTabTypes));

export const detailTabsNeedSave = (currentTabs, baselineTabs, activeTabTypes = []) => {
  const currentPayload = serializeDetailTabsPayload(currentTabs, activeTabTypes);
  const baselinePayload = serializeDetailTabsPayload(
    normalizeDetailTabsFromApi(baselineTabs, activeTabTypes),
    activeTabTypes,
  );
  return currentPayload !== baselinePayload;
};

export const getTabTypeLabel = (tabKey, tabTypes = []) => {
  const type = tabTypes.find((item) => item.TabKey === tabKey);
  return type?.DefaultTitle || tabKey;
};

export const getTabTypeHelp = (tabKey, tabTypes = []) => {
  const type = tabTypes.find((item) => item.TabKey === tabKey);
  return type?.HelpText || '';
};
